import React from 'react';
import PropTypes from 'prop-types';
import { benefitTypes } from '../../../../constants';
import Comfort from '../../../components/SvgIcons/Comfort';
import Uptime from '../../../components/SvgIcons/Uptime';
import HealthAndSafety from '../../../components/SvgIcons/HealthAndSafety';
import RefrigerationFoodSafety from '../../../components/SvgIcons/RefrigerationFoodSafety';
import Connectivity from '../../../components/SvgIcons/Connectivity';
import EnergyEfficiency from '../../../components/SvgIcons/EnergyEfficiency';
import ControlsPerformance from '../../../components/SvgIcons/ControlsPerformance';
import DataConnectivity from '../../../components/SvgIcons/DataConnectivity';
import ReduceConsumable from '../../../components/SvgIcons/ReduceConsumable';
import PreventCostlyPartsFailure from '../../../components/SvgIcons/PreventCostlyPartsFailure';

const useStyles = {
  root: ({ fontSize }) => ({
    fontSize,
    height: '0.8em',
  }),
};

/**
 * These are just sample icons, will be changed
 */
const BenefitIcons = ({ benefit, fontSize }) => {
  switch (benefit) {
    case benefitTypes.CMFRT: {
      return <Comfort sx={{ root: useStyles.root({ fontSize }) }} />;
    }
    case benefitTypes.UPT: {
      return <Uptime sx={{ root: useStyles.root({ fontSize }) }} />;
    }
    case benefitTypes['H&S']: {
      return <HealthAndSafety sx={{ root: useStyles.root({ fontSize }) }} />;
    }
    case benefitTypes.RFS: {
      return (
        <RefrigerationFoodSafety sx={{ root: useStyles.root({ fontSize }) }} />
      );
    }
    case benefitTypes.CONN: {
      return <Connectivity sx={{ root: useStyles.root({ fontSize }) }} />;
    }
    case benefitTypes.EE: {
      return <EnergyEfficiency sx={{ root: useStyles.root({ fontSize }) }} />;
    }
    case benefitTypes.CNTRL_PERF: {
      return (
        <ControlsPerformance sx={{ root: useStyles.root({ fontSize }) }} />
      );
    }
    case benefitTypes.DCONN: {
      return <DataConnectivity sx={{ root: useStyles.root({ fontSize }) }} />;
    }
    case benefitTypes.MAINTC: {
      return <ReduceConsumable sx={{ root: useStyles.root({ fontSize }) }} />;
    }
    case benefitTypes.MAINTP: {
      return (
        <PreventCostlyPartsFailure
          sx={{ root: useStyles.root({ fontSize }) }}
        />
      );
    }
    default: {
      return null;
    }
  }
};

BenefitIcons.propTypes = {
  /**
   * benefit
   */
  benefit: PropTypes.string,
  /**
   * Icon fontsize
   */
  fontSize: PropTypes.number,
};
BenefitIcons.defaultProps = {
  fontSize: 24,
};

export default BenefitIcons;
